var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loader",class:{ 'loader--active': _vm.isLoading }},[_c('div',{staticClass:"loader__text"},[_vm._v(" Loading... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }